import React from "react";
import { InView } from "react-intersection-observer";

import AudioPlayer from "../AudioPlayer";
import CallToAction from "../CallToAction";
import Carousel from "../Carousel";
import Columns from "../Columns";
import ContentImageColumn from "../ContentImageColumn";
import CTABlock from "../CTABlock";
import Divider from "../Divider";
import FeaturedPosts from "../FeaturedPosts";
import FixedImageColumn from "../FixedImageColumn";
import Form from "../Form";
import GatedContent from "../GatedContent";
import GatedForm from "../GatedForm";
import ImageColumns from "../ImageColumns";
import LogoSlider from "../LogoSlider";
import LogoSlider1 from "../LogoSlider1";
import Media from "../Media";
import MediaColumns from "../MediaColumns";
import Posts from "../Posts";
import PostsArchive from "../PostsArchive";
import Stats from "../Stats";
import Team from "../Team";
import TextCarousel from "../TextCarousel";
import TextModule from "../TextModule";
import TextTile from "../TextTile";
import Tout from "../Tout";
import YoutubeEmbeds from "../YoutubeEmbeds";
import YoutubePlaylist from "../YoutubePlaylist";

const ComponentComposer = ({ component, index, previousComponent, lastItem, isPost, location }) => {
	const componentList = {
		audio_player: AudioPlayer,
		call_to_action: CallToAction,
		carousel: Carousel,
		columns: Columns,
		cta_block: CTABlock,
		divider: Divider,
		featured_posts: FeaturedPosts,
		fixed_image_column: FixedImageColumn,
		form: Form,
		gated_content: GatedContent,
		gated_form: GatedForm,
		image_columns: ImageColumns,
		image_content_block: ContentImageColumn,
		logo_slider_1_row: LogoSlider1,
		logo_slider: LogoSlider,
		media_columns: MediaColumns,
		media: Media,
		posts_archive: PostsArchive,
		posts: Posts,
		stats: Stats,
		team_columns: Team,
		text_carousel: TextCarousel,
		text_module: TextModule,
		text_tiles: TextTile,
		tout: Tout,
		youtube_embeds: YoutubeEmbeds,
		youtube_playlist: YoutubePlaylist,
	};

	const currentBackgroundColor = component?.primary.background_color;
	const previousBackgroundColor = previousComponent?.primary.background_color;

	const ComponentType = componentList[component.slice_type]

	const addPadding = (index === 0 && !isPost) || (currentBackgroundColor?.toLowerCase() !== previousBackgroundColor?.toLowerCase());

	const componentInView = background => {
		// console.log('background', background);
	};

	const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
	if (ComponentType) {
		return (
			<InView rootMargin={`${(vh / 2.1) * -1}px`} onChange={inView => inView && componentInView(component.primary.background_color)}>
				<ComponentType
					addPadding={addPadding}
					content={component}
					isPost={isPost}
					lastItem={lastItem}
					componentIndex={index}
					location={location}
				/>
			</InView>
		)
	}
	else {
		return (
			<div data-component="component-error"></div>
		)
	}
};

export default ComponentComposer;
